import {
  MIN_BAG_ITEMS,
  MIN_BAR_ITEMS,
  MIN_BASE_PERCENT,
  MIN_BISCUIT_ITEMS,
  MIN_SMALL_TUBE_INGREDIENT_VOLUME,
  SMALL_TUBE_VOLUME,
} from '@/consts/mix'
import type { Mix } from '@/models/Mix'

class MixValidator {
  private errors: { key: string; data?: unknown }[] = []
  constructor(private mix: Mix) {}

  validate() {
    // Resets errors
    this.errors = []

    // if(isEmpty(this.mix.kind)) {
    //   this.errors.push("Mix kind cant be null.")
    // }

    // if(['musli', 'porridge'].some(this.mix.kind)) {
    //   this.errors.push("Mix kind is not defined or wrong.")
    // }

    if (this.mix.state === 'closed' && this.mix.items.length === 0) {
      this.errors.push({ key: 'mix_does_not_have_any_items' })
    }

    switch (this.mix.kind) {
      case 'musli':
      case 'porridge': {
        this.baseMixCase()
        break
      }
      case 'dry_fruits':
      case 'crunchy_fruits': {
        this.crunchyFruitsCase()
        break
      }
      case 'biscuits': {
        this.biscuitsCase()
        break
      }
      case 'mixit_bars': {
        this.mixitBarsCase()
        break
      }
      case 'fruit_bags': {
        this.bagsCase()
        break
      }
      // No default
    }
  }

  baseMixCase() {
    const baseItems = this.findBaseItems()
    const [base] = baseItems

    if (this.mix.state === 'closed' && base === undefined) {
      this.errors.push({ key: 'base_not_found' })
    }

    if (base) {
      if (baseItems.length > 1) {
        this.errors.push({ key: 'mix_cant_have_more_than_1_base' })
      }
      if (base.amount > 1) {
        this.errors.push({ key: 'base_quantity_is_more_than_1' })
      }
    }

    if (this.mix.hasBase && this.mix.basePercent < MIN_BASE_PERCENT) {
      this.errors.push({ key: 'mix_is_full' })
    }
  }

  crunchyFruitsCase() {
    if (this.mix.nonBaseItemsVolume > SMALL_TUBE_VOLUME) {
      this.errors.push({ key: 'mix_is_full' })
    }

    if (this.mix.state === 'closed' && this.mix.nonBaseItemsVolume < MIN_SMALL_TUBE_INGREDIENT_VOLUME) {
      const currentVolume = Math.round((this.mix.nonBaseItemsVolume / this.mix.tubeVolume) * 100)
      const maxVolume = Math.round((MIN_SMALL_TUBE_INGREDIENT_VOLUME / this.mix.tubeVolume) * 100)
      this.errors.push({
        key: 'mix_is_not_full_enough',
        data: { current_volume: currentVolume, max_volume: maxVolume },
      })
    }
  }

  biscuitsCase() {
    if (this.mix.totalNonBaseItemsQuantity > MIN_BISCUIT_ITEMS) {
      this.errors.push({ key: 'mix_is_full' })
    }

    if (this.mix.state === 'closed' && this.mix.totalNonBaseItemsQuantity < MIN_BISCUIT_ITEMS) {
      this.errors.push({ key: 'mix_has_less_items_than_x', data: { current_count: 7 } })
    }
  }

  bagsCase() {
    if (this.mix.totalNonBaseItemsQuantity > MIN_BAG_ITEMS) {
      this.errors.push({ key: 'mix_is_full' })
    }

    if (this.mix.state === 'closed' && this.mix.totalNonBaseItemsQuantity < MIN_BAG_ITEMS) {
      this.errors.push({ key: 'mix_has_less_items_than_x', data: { current_count: 10 } })
    }
  }

  mixitBarsCase() {
    if (this.mix.totalNonBaseItemsQuantity > MIN_BAR_ITEMS) {
      this.errors.push({ key: 'mix_is_full' })
    }

    if (this.mix.state === 'closed' && this.mix.totalNonBaseItemsQuantity < MIN_BAR_ITEMS) {
      this.errors.push({ key: 'mix_has_less_items_than_x', data: { current_count: 8 } })
    }
  }

  findBaseItems() {
    return this.mix.items.filter((item) => item.ingredient.isBase)
  }

  isValid() {
    this.validate()
    return this.errors.length === 0
  }

  getErrors() {
    return this.errors
  }
}

export default MixValidator
